if (!customElements.get('loop-navigation')) {
  customElements.define('loop-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.blocked = [];
      this.details = this.querySelector('details');
      if (!this.details) return;
      this.summary = this.querySelector('summary');
      this.panel = this.details.querySelector('.mobile-navigation');
      this.desktop = matchMedia('(min-width: 1281px)');
      this.summary.addEventListener('click', (event) => {
        if (this.desktop.matches) return;
        event.preventDefault();
        this.setMenu(!this.details.open || this.closing);
      }, options);
      this.details.addEventListener('toggle', () => this.sync(), options);
      this.desktop.addEventListener('change', () => { if (this.desktop.matches) this.setMenu(false, true); }, options);
      this.addEventListener('keydown', (event) => {
        if (!this.details.open || this.desktop.matches) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); this.summary.focus(); }
        if (event.key === 'Tab') {
          const targets = [...this.querySelectorAll('summary, a[href]')].filter(el => el.getClientRects().length);
          const first = targets[0], last = targets.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }, options);
      this.querySelector('nav').addEventListener('click', (event) => { if (event.target.closest('a')) this.close(); }, options);
      this.sync();
    }
    sync() {
      const open = this.details.open && !this.desktop.matches;
      if (open && !this.blocked.length) {
        this.blocked = [...document.querySelectorAll('main')].map(el => [el, el.inert]);
        this.blocked.forEach(([el]) => { el.inert = true; });
      } else if (!open) this.restore();
    }
    restore() { this.blocked.forEach(([el, previous]) => { el.inert = previous; }); this.blocked = []; }
    setMenu(open, immediate = false) {
      const wasOpen = this.details.open;
      const style = wasOpen && this.panel ? getComputedStyle(this.panel) : null;
      const start = {
        opacity: style?.opacity || '0',
        transform: style?.transform === 'none' ? 'translateY(0)' : style?.transform || 'translateY(-16px)',
      };
      this.animation?.cancel();
      this.closing = !open;
      if (!this.panel || immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.details.open = open;
        this.closing = false;
        this.sync();
        return;
      }
      if (!wasOpen && !open) return;
      this.details.open = true;
      this.sync();
      const animation = this.panel.animate([
        start,
        { opacity: open ? '1' : '0', transform: open ? 'translateY(0)' : 'translateY(-16px)' },
      ], { duration: open ? 320 : 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' });
      this.animation = animation;
      animation.finished.then(() => {
        if (this.animation !== animation) return;
        this.details.open = open;
        this.closing = false;
        this.animation = null;
        animation.cancel();
        this.sync();
      }).catch(() => {});
    }
    close() { this.setMenu(false); }
    disconnectedCallback() { this.animation?.cancel(); this.controller?.abort(); this.restore(); }
  });
}
